export default {"src":"/_next/static/media/GOAT.dd8f4ba3.svg","height":200,"width":400,"blurWidth":0,"blurHeight":0};